import { IPlansService } from "../domain/interfaces/IPlansService";
import { IPlans } from "../presentation/interfaces/IPlans";

export const GetPlanUseCase = async (service: IPlansService, planId: string): Promise<IPlans> => {
    return service.getPlan(planId);
}